import hljs from 'highlight.js/lib/common';

(function () {
    // Syntax highlighting for code blocks in rendered posts
    document.querySelectorAll('.prose pre code').forEach(function (block) {
        try { hljs.highlightElement(block); } catch (e) {}
    });

    // Reactions — likes + star rating (anonymous, deduped by visitor token)
    var box = document.getElementById('reactions');
    if (box) {
        var meta = document.querySelector('meta[name="csrf-token"]');
        var csrf = meta ? meta.getAttribute('content') : '';
        var ratingsLabel = box.dataset.ratingsLabel || '';
        var token = '';
        try {
            token = localStorage.getItem('hxa-visitor') || '';
            if (!token) {
                token = (window.crypto && crypto.randomUUID)
                    ? crypto.randomUUID()
                    : (Date.now() + '-' + Math.random().toString(36).slice(2));
                localStorage.setItem('hxa-visitor', token);
            }
        } catch (e) {}

        var likeBtn   = box.querySelector('.react-like');
        var likeCount = box.querySelector('.react-like__count');
        var stars     = box.querySelectorAll('.react-star');
        var starSet   = box.querySelector('.react-stars__set');
        var avgEl     = box.querySelector('.react-stars__avg');
        var myRating  = 0;

        var post = function (url, body) {
            return fetch(url, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': csrf, 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            }).then(function (r) { return r.json(); });
        };

        var paintStars = function (n) {
            stars.forEach(function (st, i) { st.classList.toggle('is-filled', i < n); });
        };

        var render = function (s) {
            if (!s) return;
            likeCount.textContent = s.likes;
            likeBtn.classList.toggle('is-active', !!s.liked);
            likeBtn.setAttribute('aria-pressed', String(!!s.liked));
            myRating = s.my_rating || 0;
            paintStars(myRating);
            avgEl.textContent = s.stars_count
                ? (Number(s.stars_avg).toFixed(1) + ' · ' + s.stars_count + ' ' + ratingsLabel)
                : '';
        };

        stars.forEach(function (st) {
            st.addEventListener('mouseenter', function () { paintStars(parseInt(st.dataset.val, 10)); });
            st.addEventListener('click', function () {
                post(box.dataset.starUrl, { token: token, rating: parseInt(st.dataset.val, 10) }).then(render).catch(function () {});
            });
        });
        if (starSet) starSet.addEventListener('mouseleave', function () { paintStars(myRating); });

        likeBtn.addEventListener('click', function () {
            post(box.dataset.likeUrl, { token: token }).then(render).catch(function () {});
        });

        fetch(box.dataset.stateUrl + '?token=' + encodeURIComponent(token), { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(render)
            .catch(function () {});
    }

    // Share — copy link
    var copyBtn = document.querySelector('.share-copy');
    if (copyBtn) {
        copyBtn.addEventListener('click', function () {
            var url = copyBtn.dataset.copy;
            var done = function () {
                var note = document.getElementById('share-copied');
                if (note) {
                    note.hidden = false;
                    setTimeout(function () { note.hidden = true; }, 2000);
                }
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(done).catch(function () {});
            } else {
                var tmp = document.createElement('input');
                tmp.value = url;
                document.body.appendChild(tmp);
                tmp.select();
                try { document.execCommand('copy'); done(); } catch (e) {}
                document.body.removeChild(tmp);
            }
        });
    }
})();
